import React from "react";
import "../styles/Home.css";
import NIVIntro from "./NIVIntro";
import BookShowcase from "./Books";
import { Helmet, HelmetProvider } from "react-helmet-async";
const Home = () => {
  return (
    <div>
      <title>Intro to Noninvasive Ventilation (NIV)</title>
      <HelmetProvider>
        <Helmet>
          <title>Intro to Noninvasive Ventilation (NIV)</title>
          <meta
            name="description"
            content="Learn how Noninvasive Ventilation (NIV) supports patients with conditions like DMD, ALS, and SMA without invasive procedures."
          />
          <meta
            name="keywords"
            content="Noninvasive Ventilation, NIV, DMD, ALS, SMA, respiratory support, neuromuscular diseases"
          />
          <meta
            property="og:image"
            content="https://doctorbach.com/favicon.png"
          />
          <meta property="og:title" content="Introduction to NVS" />
          <meta
            property="og:description"
            content="Explore how NIV helps manage respiratory conditions such as Duchenne Muscular Dystrophy, ALS, and SMA."
          />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://doctorbach.com/" />
        </Helmet>
      </HelmetProvider>
      <div className="home">
        <NIVIntro />
      </div>
      <BookShowcase />
    </div>
  );
};

export default Home;
